import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { Database, CheckCircle, Loader2 } from 'lucide-react';

const sampleProperties = [
  {
    title: "The Magnolias Ultra-Luxury Condominium",
    type: "3 BHK Flat",
    price: 45000000,
    location: "Golf Course Road, Gurugram",
    builder: "DLF Group",
    furnishing: "Fully Furnished",
    area: "3,800 sq.ft.",
    bathrooms: 4,
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1600&q=80",
    description: "An iconic luxury residence overlooking lush golf greens, featuring high ceilings, private elevator lobby, world-class concierge service, and elite community living."
  },
  {
    title: "M3M Golfestate Presidential Villa",
    type: "Luxury Villa",
    price: 75000000,
    location: "Sector 65, Gurugram",
    builder: "M3M Group",
    furnishing: "Fully Furnished",
    area: "5,200 sq.ft.",
    bathrooms: 5,
    image: "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?auto=format&fit=crop&w=1600&q=80",
    description: "A masterpiece of modern architecture with resort-style landscaping, private plunge pool, Italian modular kitchen, and exclusive 9-hole golf course views."
  },
  {
    title: "Godrej Aristocrat 2 BHK Premium Suite",
    type: "2 BHK Flat",
    price: 16500000,
    location: "Sector 49, Gurugram",
    builder: "Godrej Properties",
    furnishing: "Semi-Furnished",
    area: "1,400 sq.ft.",
    bathrooms: 2,
    image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1600&q=80",
    description: "Thoughtfully crafted forest-themed luxury residence featuring expansive balconies, excellent cross ventilation, multi-tier security, and modern wellness zones."
  },
  {
    title: "Trump Tower Sky Penthouse",
    type: "Penthouse",
    price: 95000000,
    location: "Sector 65, Gurugram",
    builder: "Tribeca & M3M",
    furnishing: "Fully Furnished",
    area: "6,000 sq.ft.",
    bathrooms: 6,
    image: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1600&q=80",
    description: "A signature glass-façade sky mansion offering transcendent skyline views, temperature-controlled indoor pool, private home theater, and legendary Trump hospitality."
  }
];

export default function SeedDatabase() {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleSeedData = async () => {
    setLoading(true);
    setError(null);
    try {
      const propertiesRef = collection(db, "properties");
      
      for (const prop of sampleProperties) {
        await addDoc(propertiesRef, prop);
      }

      setSuccess(true);
    } catch (err) {
      console.error("Error seeding data:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto my-16 p-8 bg-white border border-slate-200 rounded-3xl shadow-xl text-center">
      <div className="w-12 h-12 bg-indigo-50 text-indigo-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-sm">
        <Database className="w-6 h-6" />
      </div>
      <h3 className="text-lg font-bold text-slate-900 mb-2">Seed Sample Properties</h3>
      <p className="text-slate-500 text-xs mb-6 font-normal leading-relaxed">
        Click below to instantly upload the sample luxury listings to your Firebase Firestore `properties` collection.
      </p>

      {success ? (
        <div className="inline-flex items-center gap-2 px-4 py-2.5 bg-emerald-50 text-emerald-700 rounded-xl text-xs font-semibold shadow-sm">
          <CheckCircle className="w-4 h-4 text-emerald-600" /> Data Added Successfully!
        </div>
      ) : (
        <button
          onClick={handleSeedData}
          disabled={loading}
          className="w-full py-3 bg-indigo-600 hover:bg-indigo-500 text-white font-semibold rounded-xl text-xs uppercase tracking-wider transition shadow-lg shadow-indigo-600/30 flex items-center justify-center gap-2"
        >
          {loading ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" /> Uploading to Firebase...
            </>
          ) : (
            "Upload Sample Data"
          )}
        </button>
      )}

      {error && (
        <p className="text-rose-600 text-xs mt-3 font-medium">Error: {error}</p>
      )}
    </div>
  );
}